/*
    how to setup the redux?
    1. Firstly we need to install redux, and the toolkit:-
      npm install redux --save
      npm install @reduxjs/toolkit --save

      The redux is the old library, which has createStore, combineReducer and so on.
      The @reduxjs/toolkit is the new library, where we have the configureStore, createAction, createSelectore and so on.

      The createStore is deprecated, so we will be using the configureReducer.

    2. Once the installation is done, create the reducers.
     ex:-
        const addToCartReducer = (state = initialState, { type, payload }) => {
          switch (type) {
            case "ADD_TO_CART":
              return { ...state, cart: [...state.cart, payload] };
            default:
              return state;
          }
        };

    3. Now inside the configureStore place this reducer and then create a Store.

    4. wrap the <App /> component in the index.js with <Provider store={store}>

    5. Now we successfully connected the react with redux 
*/

import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
import rootReducers from "./Reducers";

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducers,
  middleware: [sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

export default store;
